import * as text from './text'
import * as fetch from './fetch'
import * as styles from './styles'
import * as array from './array'
import * as device from './device'
import * as formatPercentage from './formatPercentage'

export {
  text,
  fetch,
  styles,
  array,
  device,
  formatPercentage
}
